module.exports = __webpack_public_path__ + "img/1513018005.4b658dee.jpg";